import React from 'react';
import { Box, Typography, TextField } from '@availity/element';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import joinEarlyPageStyles from '../joinEarlyPageStyles';

interface FormData {
  firstName: string;
  lastName: string;
  companyName: string;
  role: string;
  workEmail: string;
  mcpInterest: string;
  apisOfInterest: string[];
  description: string;
  [key: string]: unknown;
}

interface FormFieldProps {
  label: string;
  name: 'firstName' | 'lastName' | 'companyName' | 'workEmail';
  rules: Record<string, unknown>;
  placeholder: string;
  type?: string;
  control: Control<FormData>;
  errors: FieldErrors<FormData>;
}

const { requiredLabel, asterisk, fieldContainer, textField, errorText } = joinEarlyPageStyles;

export const RequiredLabel = ({ children }: { children: string }) => (
  <Typography sx={requiredLabel}>
    <Box component="span" sx={asterisk}>*&nbsp;</Box>{children}
  </Typography>
);

export const FormField = ({ label, name, rules, placeholder, type = 'text', control, errors }: FormFieldProps) => (
  <Box sx={fieldContainer}>
    <RequiredLabel>{label}</RequiredLabel>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <>
          <TextField
            {...field}
            onChange={(e) => {
              const value = e.target.value.slice(0, 100);
              field.onChange(value);
            }}
            onBlur={(e) => {
              const trimmedValue = e.target.value.trim();
              if (trimmedValue !== field.value) {
                field.onChange(trimmedValue);
              }
              field.onBlur();
            }}
            type={type}
            placeholder={placeholder}
            error={!!errors[name]}
            sx={textField(!!errors[name])}
          />
          {errors[name] && <Typography sx={errorText}>{errors[name]?.message}</Typography>}
        </>
      )}
    />
  </Box>
);
